import img1 from '../images/NewsCard/img1.jpg';
import img2 from '../images/NewsCard/img2.jpg';
import img3 from '../images/NewsCard/img3.jpg';
import img4 from '../images/NewsCard/img4.jpg';
import img5 from '../images/NewsCard/img5.png';
import img6 from '../images/NewsCard/img6.jpg';

export const NewsData = [
  {
    id: 0,
    image: img1,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      '<p>&mdash; Сменить профиль после 10 класса с гуманитарного на технологический и потерять год обучения.<br /> &mdash; Готовиться 1,5 года к сдаче ЕГЭ по биологии и химии, а в конце 11 класса осознать, что хочешь стать журналистом, значит нужна литература, а времени на подготовку уже не осталось.<br /> &mdash; Заниматься информатикой и профильной математикой, потому что так сказали родители, когда душа лежит к биологии и защите окружающей среды.<br /> Сколько таких историй мы слышали на профориентации в Proect104. А если бы родители и ребенок с самого начала правильно выбрали профиль.<br /> Что такое профиль или профильный класс<br />',
  },
  {
    id: 1,
    image: img2,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 2,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 3,
    image: img4,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 4,
    image: img5,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 5,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 6,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 7,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 8,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 9,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 10,
    image: img6,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 11,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 12,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 13,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 14,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 15,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 16,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 17,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 18,
    image: img3,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
  {
    id: 19,
    image: img1,
    date_posted: '23 сентября 2023',
    title: 'Как выбирать школу  по  гуманитарным направлениям',
    content:
      'Если в скором времени ваш ребенок пойдет в 1ый класс, стоит заранее определиться в какой школе он будет учится. В этой статье мы расскажем, на что обратить внимание при поиске школыю',
  },
];

export const album = [
  {
    image:
      'https://images.unsplash.com/photo-1696655496030-079414c31e06?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
  },
  {
    image:
      'https://images.unsplash.com/photo-1540479859555-17af45c78602?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  },
  {
    image:
      'https://images.unsplash.com/photo-1537655780520-1e392ead81f2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  },
  {
    image:
      'https://images.unsplash.com/photo-1531325082793-ca7c9db6a4c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  },
  {
    image:
      'https://images.unsplash.com/photo-1551966775-a4ddc8df052b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  },
  {
    image:
      'https://images.unsplash.com/photo-1596464716127-f2a82984de30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  },
];
